import React, { useEffect, useState, useContext, useRef, createRef } from 'react';
import { Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Helmet from 'react-helmet';
import * as Icon from 'react-bootstrap-icons';

import { AppContext } from '../../context/AppContext.jsx';
import { useLanguage, LanguageProvider } from "../../i18n/LanguageContext.jsx";
import HeroImage from "../../components/HeroImage.jsx";
import { getFirstImage, slugify } from '../../helpers/helperFunctions.js';
import i18n from '../../i18n/i18n.js';
import ErrorAnimation from './ErrorAnimation.jsx'


const ErrorTemplate = ({ item }) => {
	const params = useParams();
	const navigate = useNavigate();
	const { language } = useLanguage();
	const { siteMap } = useContext(AppContext);

	return (
		<>
			<HeroImage item={item} />

			{item && siteMap && (
				<>
					<div className="container my-md-10 my-5">
						<div className="row justify-content-end align-items-center">
							<div className="col-xl-5 col-lg-6 col-md-6">
								<ErrorAnimation />
							</div>
							<div className="col-xl-5 col-lg-6 col-md-6 text-center text-md-start mt-5 mt-md-0">
								<h1 className="error-code">{item.errorCode}</h1>
								<div className="ps-4 ps-md-0">
									<h2 className="error-title mt-3 mt-sm-1">{item.title}</h2>
									<p>
										{item.description}
									</p>
									<Link to={`/${language}`} style={{ width: "fit-content" }} className="d-block mt-5 text-dark rotate-arrow-hover hover-underline mx-auto mx-md-0">
										<span>{i18n[language].backToHp}</span>
										<Icon.ArrowUpRight className="text-primary ms-2" />
									</Link>
								</div>

							</div>
						</div>
					</div>
				</>
			)}
		</>
	);
}

export default ErrorTemplate;